<template>
  <div class='input' :class='props.class'>
    <input
      v-model='value'
      ref='inputRef'
      class='input__field'
      :type="props.type"
      placeholder=' '
    >
    <label class='input__label'>{{ props.label }}</label>
    <button
      v-if='props.clearable && value'
      class='receiving-search__clear'
      @click='handleClear'
    >
      <icon-close />
    </button>
  </div>
</template>

<script lang='ts' setup>
import { computed, onMounted, ref } from 'vue'
import IconClose from '@/components/images/IconClose.vue'

const props = withDefaults(defineProps<{
  class?: string
  modelValue?: string
  clearable?: boolean
  label: string
  focus?: boolean
  type?: 'text' | 'password'
}>(), {
  type: 'text'
})

const emit = defineEmits(['update:modelValue', 'clear'])

const inputRef = ref()

const value = computed({
  get: () => props.modelValue ?? '',
  set: (value: string) => {
    emit('update:modelValue', value)
  }
})

const handleClear = () => {
  value.value = ''
  emit('clear')
  inputRef.value.focus()
}

onMounted(() => {
  if (props.focus) {
    inputRef.value?.focus()
  }
})
</script>
